<div class="row">
  <div class="col-lg-12">
    <h3>Lieferbedinungen</h3>
  </div>
</div>

<div class="row">
  <div class="col-lg-6">
    @if (!loading) {
      <delivery-condition-ou-table tableName="Überlieferung" [deliveryConditionList]="overDelivery">
      </delivery-condition-ou-table>
    }
  </div>

  <div class="col-lg-6">
    @if (!loading) {
      <delivery-condition-ou-table tableName="Unterlieferung" [deliveryConditionList]="underDelivery">
      </delivery-condition-ou-table>
    }
  </div>
</div>

<div class="row">
  @if (!loading) {
    <div class="col-lg-12">
      <table class="table whitetable">
        <thead>
          <tr>
            <th colspan="2">BA Endtermin Steuerung</th>
          </tr>
          <tr>
            <th>Nutzen bis</th>
            <th>Tage vor Lieferung</th>
          </tr>
        </thead>
        <tbody>
          @for (obj of baTerminationDates; track obj) {
            <tr>
              <td>{{ obj.utilized|money }}</td>
              <td>{{ obj.days_left|money }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

@if (loading) {
  <div class="col-lg-12">
    <i class="fa fa-spinner fa-2x fa-spin" aria-hidden="true"></i>
  </div>
}
